import { buildErrorMessage } from "vite"
import MarkerProps from "./markerProps"
import { markerSizes } from "./markerSizes"

const MixedMarker = ({
  size = 'medium',
}:MarkerProps) => {

  return (
<svg width="33" height="44" viewBox="0 0 33 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4758_8011)">
<path d="M16.0768 0.993286V10.429C18.9571 10.6276 21.1422 13.0113 21.1422 15.8917C21.1422 18.7721 18.8578 21.1558 16.0768 21.3545L16.0444 43.2832C16.4417 43.2832 16.8713 43.0068 17.1693 42.7089C20.9436 38.14 31.1738 25.7247 31.1738 15.991C31.1738 6.25739 24.6185 0.993286 16.0768 0.993286Z" fill="#00324D"/>
<path d="M16.0194 0V0.993228C24.2632 0.993228 30.9179 7.64786 30.9179 15.8916C30.9179 24.1354 21.1842 37.544 17.0127 42.5102C16.7147 42.9075 16.3174 43.0068 15.8208 43.0068V44C16.5161 44 17.2113 43.702 17.6086 43.1061C21.8795 38.0406 31.7125 25.228 31.7125 15.8916C31.7125 6.55531 24.7599 0 16.0194 0Z" fill="#12253C"/>
<path d="M16.077 0.993286V10.429C13.1967 10.6276 11.0116 13.0113 11.0116 15.8917C11.0116 18.7721 13.296 21.1558 16.077 21.3545L16.0447 43.2832C15.6474 43.2832 15.2825 43.0068 14.9845 42.7089C11.2102 38.0407 0.97998 25.526 0.97998 15.7924C0.97998 6.05875 7.53529 0.993286 16.077 0.993286Z" fill="#4AA181"/>
<path d="M16.0743 0V0.993228C7.83047 0.993228 1.17585 7.64786 1.17585 15.8916C1.17585 24.1354 10.9095 37.544 15.081 42.5102C15.379 42.9075 15.5478 43.0068 16.0444 43.0068V44.0294C15.3491 44.0294 14.8824 43.702 14.4851 43.1061C10.0156 38.14 0.182617 25.3273 0.182617 15.8916C0.182617 6.45598 7.33386 0 16.0743 0Z" fill="#567F69"/>
<ellipse cx="16" cy="16" rx="6" ry="6" fill="white"/>
</g>
<defs>
</defs>
</svg>

  )
}

export default MixedMarker
